/**
 * 匠人 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const firstagent = {
    /** ***********普通用户BEGIN***************/
    // 园区列表
    parklist(params) {
        return axios.get(api + 'firstagent/parklist', { params: params })
    },
    // 列表
    list(params) {
        return axios.get(api + 'firstagent/list', { params: params })
    },
    detail(params) {
        return axios.get(api + 'firstagent/detail', { params: params })
    },
    //园区一级分销商详情
    parkdetail(params) {
        return axios.get(api + 'firstagent/parkdetail', { params: params })
    },
    remove(params) {
        return axios.post(api + 'firstagent/remove', qs.stringify(params))
    },
    edit(params) {
        return axios.post(api + 'firstagent/edit', qs.stringify(params))
    },
    reviewStatus(params) {
        return axios.post(api + 'firstagent/reviewStatus', qs.stringify(params))
    },
    //代理商列表
    agentlist(params) {
        return axios.get(api + 'firstagent/agentlist', { params: params })
    },
    //设置二级直接收款分销比例
    agentbili(params) {
        return axios.get(api + 'firstagent/agentbili', { params: params })
    },
    setagentbili(params) {
        return axios.post(api + 'firstagent/setagentbili', qs.stringify(params))
    },
    // 未绑定合伙人的 代理商列表
    noBindAgents(params) {
        return axios.get(api + 'firstagent/agentnoBindAgents', { params: params })
    },
    agentCreate(params) {
        return axios.post(api + 'firstagent/agentcreate', qs.stringify(params))
    },
    agentRemove(params) {
        return axios.post(api + 'firstagent/agentremove', qs.stringify(params))
    },
    // 2.提成记录
    tcrecord(params) {
        return axios.get(api + 'firstagent/tcrecord', { params: params })
    },
    // 9.获取提成详情
    recorddetail(params) {
        return axios.get(api + 'firstagent/recorddetail', { params: params })
    },

    bili(params) {
        return axios.post(api + 'firstagent/setBili', qs.stringify(params))
    },
    //园区比例
    parkbili(params) {
        return axios.post(api + 'firstagent/parksetBili', qs.stringify(params))
    },
    //未绑定其他分销商的用户
    nobindagent(params) {
        return axios.get(api + 'firstagent/nobindagent', { params: params })
    },
    //园区添加一级分销商
    firstagentadd(params) {
        return axios.post(api + 'firstagent/firstagentadd', qs.stringify(params))
    },
}

// 导出接口
export default firstagent
